module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Server details for synchronisation":"Serverdaten für Synchronisation","Create an account":"Account anlegen","Confirm e-mail":"E-Mail bestätigen","Please check your e-mail for a confirmation link.":"Bitte schau in deine E-Mails, du bekommst einen Bestätigungslink."}}')
  delete Component.options._Ctor
}
